/**
 * demo.js
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 *
 * Copyright 2017, Codrops
 * http://www.codrops.com
 */

import hasTouch from './utils/hasTouch';

class App {
  constructor() {
    // ontouchstartがあるかどうかでspかどうか判断。
    this.isMobile = hasTouch();
  }
}

export default new App();